document.addEventListener('DOMContentLoaded', function() {
  const filterSection = document.querySelector('.find-a-store-section');
  if (!filterSection) return;

  const filterItems = filterSection.querySelectorAll('.find-a-store-section-content-filters-item');
  const storeItems = filterSection.querySelectorAll('.find-a-store-section-content-stores-item');

  // Set "All" filter as active by default
  const firstFilter = filterItems[0];
  if (firstFilter) {
    const firstFilterText = firstFilter.querySelector('.find-a-store-section-content-filters-item-label')?.textContent.trim();
    if (firstFilterText && firstFilterText.toLowerCase() === 'all') {
      firstFilter.classList.add('active');
    }
  }

  filterItems.forEach(function(filterItem) {
    filterItem.addEventListener('click', function() {
      const filterText = this.querySelector('.find-a-store-section-content-filters-item-label')?.textContent.trim();
      if (!filterText) return;

      // Remove active class from all filters
      filterItems.forEach(function(item) {
        item.classList.remove('active');
      });

      // Add active class to clicked filter
      this.classList.add('active');

      // Filter store cards
      const filterValue = filterText.toLowerCase();
      
      storeItems.forEach(function(storeItem) {
        const card = storeItem.querySelector('.store-card');
        if (!card) return;
        
        const cardCity = card.getAttribute('data-city')?.toLowerCase() || '';
        
        if (filterValue === 'all' || cardCity === filterValue) {
          storeItem.style.display = '';
        } else {
          storeItem.style.display = 'none';
        }
      });
    });
  });
});

